import { FovTypography } from 'components';
import { EyeOutlined } from 'components/icons';
import {
    DateTimeContainer,
    JobId,
    TruncatedCell,
    RowMenuItem,
} from '../Jobs/styles';

const previewUrl = preview => (
    preview.rpc_guid ? `https://preview.archvision.app/fovea/${preview.rpc_guid}` : null
);

export const listColumns = selectedTheme => ([
    {
        title: 'Job ID',
        key: 'job_guid',
        width: 320,
        alignContent: 'left',
        render: (text, preview) => (
            <JobId title={preview.job_guid}>
                {preview.job_guid ?? '-'}
            </JobId>
        ),
    },
    {
        title: 'File Name',
        key: 'file_name',
        width: 240,
        alignContent: 'left',
        render: (text, preview) => (
            <TruncatedCell title={preview.file_name}>
                {preview.file_name ?? '-'}
            </TruncatedCell>
        ),
    },
    {
        title: 'Job Type',
        key: 'type',
        width: 185,
        alignContent: 'left',
        render: (text, preview) => (
            <TruncatedCell title={preview.type}>
                {preview.type ?? '-'}
            </TruncatedCell>
        ),
    },
    {
        title: 'Client ID',
        key: 'client_id',
        width: 160,
        alignContent: 'left',
        render: (text, preview) => (
            <TruncatedCell title={preview.client_id}>
                {preview.client_id ?? '-'}
            </TruncatedCell>
        ),
    },
    {
        title: 'Email',
        key: 'notification_email',
        width: 240,
        alignContent: 'left',
        render: (text, preview) => (
            <TruncatedCell title={preview.notification_email}>
                {preview.notification_email ?? '-'}
            </TruncatedCell>
        ),
    },
    {
        title: 'Application',
        key: 'requesting_application',
        width: 140,
        alignContent: 'left',
        render: (text, preview) => (
            <TruncatedCell title={preview.requesting_application}>
                {preview.requesting_application ?? '-'}
            </TruncatedCell>
        ),
    },
    {
        title: 'Created ↓',
        key: 'created_at',
        width: 140,
        render: (text, preview) => (
            <DateTimeContainer>
                <FovTypography>
                    {preview.created_at ? new Date(preview.created_at).toLocaleDateString(
                        'en-US', { year: 'numeric', month: 'short', day: 'numeric' }) : '-'}
                </FovTypography>

                <FovTypography>
                    {preview.created_at ? new Date(preview.created_at).toLocaleTimeString(
                        'en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) : '-'}
                </FovTypography>
            </DateTimeContainer>
        ),
    },
    {
        title: '',
        key: 'actions',
        width: 120,
        alignContent: 'center',
        render: (text, preview) => {
            const url = previewUrl(preview);

            return (
                <RowMenuItem
                    target='_blank'
                    rel='noreferrer'
                    href={url ?? undefined}
                    $disabled={!url}
                    $selectedTheme={selectedTheme}
                    title={url ? undefined : 'This preview has no model to open'}
                >
                    <EyeOutlined width={16} height={16} />
                    Preview
                </RowMenuItem>
            );
        },
    },
]);
